import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NzNoAnimationDirective } from 'ng-zorro-antd/core/no-animation';
import { NzSelectSizeType } from 'ng-zorro-antd/select';
import { Observable } from 'rxjs';
import { CustomerDataService } from 'src/app/services/customer-data.service';
import { IDeactivateGuard } from 'src/app/guards/deactivate-guard.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, IDeactivateGuard {

  constructor(private activateroute: ActivatedRoute, private route: Router, private data: CustomerDataService, private fb: UntypedFormBuilder) {

  }

  public styleObject = {
    top: '160px',
    right: '100px',
    width: '500px',
    height: '400px',
  };
  size: NzSelectSizeType = 'small';
  public isVisible = true;
  public editId: any;
  public index: any;
  public isAddMode!: boolean;
  public companydetails: any = [];
  public list: any = [];
  public submit = false;
  public frmRegister!: UntypedFormGroup;
  public features: any = {
    solar: { ea: 'Energy Availability', pc: 'Powercurve', analytics: 'Analytics', vis: 'Visualization', observations: 'observations', cmms: 'CMMS' },
    wind: { ea: 'Energy Availability', pc: 'Powercurve', analytics: 'Analytics', vis: 'Visualization', observations: 'observations', cmms: 'CMMS' }
  };

  onclick(data: any): void {
    // this.submit = true;
    if (this.isAddMode) {
      this.data.setcompany({
        name: data.name,
        id: (new Date().getTime()) + '', // (new Date().getTime().toString())
        features: {
          solar: data.solar,
          wind: data.wind
        }
      });
    }
    else {
      this.data.update(
        {
          name: data.name,
          id: this.editId,
          features: {
            solar: data.solar,
            wind: data.wind
          }
        }, this.index
      );
    }

    this.route.navigate([`/customers`], { relativeTo: this.activateroute });
    // tslint:disable-next-line: forin
    for (const i in this.frmRegister.controls) {
      this.frmRegister.controls[i].markAsDirty();
      this.frmRegister.controls[i].updateValueAndValidity();
    }

  }

  handleOk(): void {
    this.route.navigate([`/customers`], { relativeTo: this.activateroute });
    // this.form.reset();
    this.submit = true;
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.route.navigate([`/customers`], { relativeTo: this.activateroute });
  }
  canExit(): any {
    if (confirm('Are you sure you want to exit')) {
      return true
    }
    this.route.navigate([`/customers`], { relativeTo: this.activateroute });

  }
  /*  Delete(index: any): void {
     this.nani.splice(index, 1) ;
    }
  */
  ngOnInit(): void {
    this.activateroute.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('id');
      this.editId = id;
      this.isAddMode = !id;

    });
    this.frmRegister = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      solar: new UntypedFormControl([]),
      wind: new UntypedFormControl([]),

    });
    this.data.message.subscribe(sites => {
      // console.log(sites)
      sites.forEach((value: any, i: any) => {
        if (value.id === this.editId) {
          this.index = i;
          this.companydetails = value;
        }
      }


      );

    });

    if (this.editId) {
      this.frmRegister.patchValue({
        name: this.companydetails.name,
        solar: this.companydetails.features.solar,
        wind: this.companydetails.features.wind
      });
    } else {

    }
    // console.log(this.companydetails)

    const menu = Object.keys(this.features.solar);
    this.list = menu;

    // this.menu = console.log( Object.entries(this.features.solar));
    /*       form = this.fb.group({
        name: ['', [Validators.required]],
        solar: [''],
        wind: [''],
      });
       this.data.getCompanies().subscribe(sites => {
          const sitedetails: any = sites.find((x: any) => x.id === this.siteId);
          console.log(this.companydetails = sitedetails);
        });
             */
  }





}
